import { StandardChip } from "../../../../../../shared/components/badges/StandardChip"
import type { StandardChipVariantType } from "../../../../../../shared/components/badges/StandardChip"
import { MeetingAudienceFilterType } from "../../../../../../shared/components/filters/orderTypeFilter/helpers"
import { LocalizedEnum } from "../../../../../localization/components/AppLocalized"
import type { MeetingAudience } from "../../serviceCenterHomeTypes"

const MEETING_AUDIENCE_CHIP_VARIANTS: Record<MeetingAudience, StandardChipVariantType> = {
    [MeetingAudienceFilterType.INTERNAL]: "grey",
    [MeetingAudienceFilterType.EXTERNAL]: "yellow",
}

type MeetingAudienceChipProps = Readonly<{
    audience?: MeetingAudience
}>

export function MeetingAudienceChip({ audience }: MeetingAudienceChipProps) {
    if (!audience) return null

    return (
        <LocalizedEnum base="service-center-reports-dashboard-meetings-list-row-audience" enumValue={audience}>
            <StandardChip variant={MEETING_AUDIENCE_CHIP_VARIANTS[audience]} placement="table" size="small">
                {audience}
            </StandardChip>
        </LocalizedEnum>
    )
}
